module.exports = __webpack_public_path__ + "img/4.f708e40d.png";